import React, { useEffect, useId, useState } from 'react';
import { useStateContext } from '../Contexts/ContextProvider';
import AxiosClient from '../assets/AxiosClient';

const ConferenceDropdown = ({ conferenceId, setConferenceId, compact = false }) => {
    const [conferences, setConferences] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { LastSelectedConference, setLastSelectedConference } = useStateContext();
    const selectId = useId();
    const selectedId = conferenceId ?? LastSelectedConference ?? '';

    useEffect(() => {
        if (LastSelectedConference != null && setConferenceId) {
            setConferenceId(LastSelectedConference);
        }
    }, [LastSelectedConference, setConferenceId]);

    useEffect(() => {
        if (!compact) return undefined;

        let isActive = true;
        const fetchConferences = async () => {
            try {
                const response = await AxiosClient.get('/conferences');
                if (isActive) setConferences(response.data.conferences || []);
            } catch (error) {
                console.error('Error fetching conferences:', error);
            } finally {
                if (isActive) setIsLoading(false);
            }
        };

        fetchConferences();
        return () => {
            isActive = false;
        };
    }, [compact]);

    const selectConference = (value) => {
        const selectedConference = conferences.find(conference => String(conference.id) === value);
        const nextId = selectedConference?.id ?? null;
        if (setConferenceId) setConferenceId(nextId);
        setLastSelectedConference(nextId);
    };

    if (!compact) return null;

    return (
        <div className="conference-picker conference-picker--navbar">
            <i className="material-icons" aria-hidden="true">event</i>
            <label className="visually-hidden" htmlFor={selectId}>Select conference</label>
            <select
                id={selectId}
                className="form-select"
                value={selectedId == null ? '' : String(selectedId)}
                onChange={(event) => selectConference(event.target.value)}
                aria-label="Select conference"
                aria-busy={isLoading}
                disabled={isLoading || conferences.length === 0}
            >
                <option value="">
                    {isLoading ? 'Loading events...' : conferences.length ? 'Select event' : 'No events available'}
                </option>
                {conferences.map(conference => (
                    <option key={conference.id} value={String(conference.id)}>
                        {conference.en_title}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ConferenceDropdown;
